import React, { useState } from "react";
import { X, Download, Loader2, CheckCircle2 } from "lucide-react";
import { submitLead, emptyLeadForm } from "../lib/api";

const BrochureDownloadModal = ({ courseName, fileUrl, fileName, source, onClose }) => {
  const [form, setForm] = useState(emptyLeadForm());
  const [status, setStatus] = useState({ state: "idle", message: "" });

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", message: "" });

    try {
      await submitLead({
        ...form,
        interest: courseName,
        source: source || "brochure-download",
        formType: "brochure",
      });
    } catch (err) {
      // Don't let a lead-capture failure block the brochure download.
    }

    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    setStatus({ state: "success", message: "Thanks! Your download should begin shortly." });
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-[#F8F9FA] border border-gray-100 rounded-2xl p-8 shadow-2xl max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-5 right-5 w-9 h-9 rounded-full border border-gray-200 text-gray-500 hover:text-[#15348C] hover:border-[#15348C]/40 flex items-center justify-center transition-colors bg-white"
        >
          <X size={16} />
        </button>

        <h2 className="text-2xl lg:text-3xl font-bold text-[#15348C]">Download course brochure</h2>
        <p className="mt-1 text-sm text-gray-500">Our learning advisor will reach out soon.</p>
        <p className="mt-2 text-[#F57C20] font-semibold">{courseName}</p>

        <form onSubmit={submit} className="mt-6 grid sm:grid-cols-2 gap-4">
          <ModalField label="Full Name" name="name" required placeholder="Your name" value={form.name} onChange={set("name")} />
          <ModalField label="Business Email" name="email" required type="email" placeholder="you@company.com" value={form.email} onChange={set("email")} />
          <ModalField label="Phone" name="mobile_no" placeholder="+91 ..." value={form.mobile_no} onChange={set("mobile_no")} />
          <ModalField label="Company Name" name="company_name" placeholder="Company name" value={form.company_name} onChange={set("company_name")} />
          <div className="sm:col-span-2">
            <ModalField label="Job Title" name="job_title" placeholder="e.g. Head of L&D" value={form.job_title} onChange={set("job_title")} />
          </div>

          <div className="sm:col-span-2 mt-2 flex items-center gap-4 flex-wrap">
            <button
              type="submit"
              disabled={status.state === "loading"}
              className="inline-flex items-center justify-center gap-2 bg-[#15348C] hover:bg-[#0A1F5C] text-white font-semibold px-6 h-11 rounded-md transition-colors disabled:opacity-60"
            >
              {status.state === "loading" ? (
                <><Loader2 size={16} className="animate-spin" /> Preparing…</>
              ) : (
                <>Download <Download size={16} /></>
              )}
            </button>

            {status.state === "success" && (
              <span className="text-sm text-[#4F9622] flex items-center gap-1">
                <CheckCircle2 size={16} /> {status.message}
              </span>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

const ModalField = ({ label, name, value, onChange, type = "text", required, placeholder }) => (
  <div>
    <label className="text-sm font-semibold text-[#15348C]">
      {label}{required && <span className="text-[#F57C20]">*</span>}
    </label>
    <input
      type={type}
      name={name}
      value={value}
      required={required}
      placeholder={placeholder}
      onChange={onChange}
      className="mt-1 w-full bg-white border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-[#6BBE32] transition-colors"
    />
  </div>
);

export default BrochureDownloadModal;
